import { ArrowRight, Search, Layers, TrendingUp } from "lucide-react";
import { Tag, H2 } from "../shared/Typography";
import { RevealGroup, RevealItem } from "../shared/Reveal";
import { posthog } from "../../lib/posthog";

const CAPABILITIES = [
  { icon: Search, label: "Explore complex data", accentCls: "text-[#1E4FD8] dark:text-[#4A90D9]" },
  { icon: Layers, label: "Model complex systems", accentCls: "text-[#5B21B6] dark:text-[#B9A5FF]" },
  { icon: TrendingUp, label: "Predict what comes next", accentCls: "text-[#C9A55E] dark:text-[#E0C088]" },
];

export function FinalStatement({ onExploreIviz, onDiscoverForesight }: { onExploreIviz: () => void; onDiscoverForesight: () => void }) {
  return (
    <section className="py-24 text-center bg-[#FAFAFA] dark:bg-[#050505] overflow-hidden">
      <RevealGroup className="relative z-10 max-w-3xl mx-auto px-6">
        <RevealItem>
          <Tag>Coharts</Tag>
        </RevealItem>

        <RevealItem>
          <H2 className="mt-6">Intelligence should do more than answer questions.</H2>
        </RevealItem>

        <RevealItem>
          <p className="text-2xl md:text-3xl font-medium tracking-[-0.01em] text-[#1E4FD8] dark:text-[#4A90D9] mt-8">
            It should help you understand what comes next.
          </p>
        </RevealItem>

        <RevealItem>
          <div className="grid grid-cols-3 gap-4 mt-16 mb-16">
            {CAPABILITIES.map(({ icon: Icon, label, accentCls }) => (
              <div key={label} className="flex flex-col items-center gap-3 py-5 border-t border-[#0A0A0F]/10 dark:border-white/10">
                <Icon size={20} className={accentCls} />
                <p className="text-xs text-[#5C5C66] dark:text-[#9A9A9A] leading-tight">{label}</p>
              </div>
            ))}
          </div>
        </RevealItem>

        <RevealItem>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => {
                posthog.capture("cta_clicked", { cta: "Explore iViz", location: "home_final_statement" });
                onExploreIviz();
              }}
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-medium rounded-full text-white dark:text-[#050505] bg-[#1E4FD8] dark:bg-[#4A90D9] transition-transform hover:scale-[1.02] active:scale-[0.98] active:brightness-90"
            >
              Explore iViz <ArrowRight size={16} />
            </button>
            <button
              onClick={() => {
                posthog.capture("cta_clicked", { cta: "Discover Foresight", location: "home_final_statement" });
                onDiscoverForesight();
              }}
              className="inline-flex items-center gap-2 px-6 py-3.5 text-sm font-medium rounded-full text-[#0A0A0F] dark:text-white border border-[#0A0A0F]/15 dark:border-white/15 hover:border-[#5B21B6] dark:hover:border-[#7C4DFF] transition-colors"
            >
              Discover Foresight <ArrowRight size={16} />
            </button>
          </div>
        </RevealItem>
      </RevealGroup>
    </section>
  );
}
